<template lang="pug">
  .cashback-notice(
    v-if="notice"
    @click="handleClick"
    v-platform-expose="handleExpose"
  )
    .order-text(
      v-if="notice.marketText && notice.orderStatus"
      :class="{ 'in-progress': notice.orderStatus == 2, 'done': notice.orderStatus == 1 }"
    ) {{ notice.marketText }}
    img.notice-img(:src="notice.imageUrl" alt="")
    .notice-info
      .notice-shop {{ notice.shopName }}
      .notice-amount
        span.coin(v-if="notice.rebateAmount") +{{ notice.rebateAmount }}
        span.text {{ notice.perceptionText }}
    .notice-arrow
</template>

<script>
import { jumpUrl } from '@/utils/tools';
import config from '@/const/config';
import SPM from '../../../common/spm';

export default {
  name: 'CashbackNotice',
  props: {
    data: {
      type: Object,
      default: null,
    },
    // 位置：top-顶部，button-底部（埋点 bannerPosition 字段值）
    position: {
      type: String,
      default: '',
    },
  },
  inject: ['cashbackStyleVersion', 'getStyleVersion'],
  computed: {
    notice() {
      const list = (this.data && this.data.bannerDataList) || [];
      return list[0] || null;
    },
    clkUrl() {
      return `https://m.hellobike.com/AppCommercialH5/${config.env !== 'pro' ? `${config.env}/` : ''
      }latest/index.html#/myorder?scene=rebateBonus`;
    },
  },
  methods: {
    handleClick() {
      jumpUrl(this.clkUrl);
      SPM.clickButton({
        buttonName: 'Welfare_onlineretailers_banner_new',
        businessInfo: {
          bannerType: 1,
          bannerPosition: this.position,
          clk_url: this.clkUrl,
          ext: '',
          takeoutTestVersion: this.cashbackStyleVersion(),
        },
      });
    },
    handleExpose() {
      SPM.moduleExpose({
        moduleId: 'Welfare_onlineretailers_banner_new',
        contentId: 'Welfare_onlineretailers_banner_new',
        exposureTimes: 1,
        businessInfo: {
          bannerType: 1,
          bannerPosition: this.position,
          clk_url: this.clkUrl,
          ext: '',
          takeoutTestVersion: this.cashbackStyleVersion(),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cashback-notice {
  display: flex;
  align-items: center;
  padding: 0.04rem;
  background: #f8f8f8;
  border-radius: 0.08rem;
  position: relative;

  .order-text {
    color: #fff;
    font-size: 0.1rem;
    height: 0.16rem;
    text-align: center;
    min-width: 0.38rem;
    position: absolute;
    left: 0;
    top: 0;
    border-top-left-radius: 0.08rem;
    border-bottom-right-radius: 0.04rem;
    width: 0.38rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    &.in-progress {
      background-color: #fb990f;
    }

    &.done {
      background-color: #07c160;
    }
  }

  .notice-img {
    width: 0.42rem;
    height: 0.42rem;
    border-radius: 0.06rem;
    flex-shrink: 0;
    object-fit: cover;
  }

  .notice-info {
    flex: 1;
    margin-left: 0.08rem;
    overflow: hidden;

    .notice-shop {
      font-size: 0.13rem;
      color: #242729;
      line-height: 0.13rem;
      height: 0.13rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .notice-amount {
      font-size: 0.12rem;
      color: #879099;
      line-height: 0.12rem;
      height: 0.12rem;
      margin-top: 0.04rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      .coin {
        color: #ff6d00;
        font-weight: 500;
      }

      .text {
        margin-left: 0.04rem;
      }
    }
  }

  .notice-arrow {
    width: 0.12rem;
    height: 0.12rem;
    flex-shrink: 0;
    margin-left: 0.05rem;
    background-image: url('https://m.hellobike.com/15e7879a35.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 0.08rem;
  }
}
</style>
